import PropTypes from 'prop-types'
import React from 'react'
import classNames from 'classnames'
import KEYCODE from 'keycode'
import { withRouter } from 'react-router-dom'

import ClickOutside from '../clickOutside'
import OnKeyDown from '../onKeyDown'
import { parseLocation } from '../../../common/utils/urlHelper'
import FiltersMultiSelectPanel from './filtersPanel/multiSelect'
import { reportOpenSearchFilterPanel } from '../../../common/analytics/filtersAnalytics'

class FiltersTags extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      showPanel: false
    }

    this.togglePanel = this.togglePanel.bind(this)
    this.onKeyDownHandler = this.onKeyDownHandler.bind(this)
  }

  onKeyDownHandler (event) {
    if (event.keyCode === KEYCODE('esc')) {
      this.togglePanel()
    }
  }

  togglePanel () {
    if (!this.state.showPanel) {
      reportOpenSearchFilterPanel('Tags')
    }
    this.setState({
      showPanel: !this.state.showPanel
    })
  }

  render () {
    const { showPanel } = this.state
    const { items, location, isAtTop } = this.props
    const parsedLocation = parseLocation(location)
    const chosenTags = parsedLocation.tags || ''

    const renderChosenTags = () => {
      if (chosenTags === '') {
        return (
          <ul className='search-facet-listing'>
            {items.map((item, index) => {
              return (
                <li key={index}>
                  <div className='search-facet-listing__link'>
                    <span className='search-facet-listing__label'>{item.key}</span>
                    <span className='search-facet-result-count'>{item.count}</span>
                  </div>
                </li>
              )
            })}
          </ul>
        )
      } else {
        return (
          <div className='search-facet-panel__status fds-u-is-hidden--no-js'>
            <div className='search-facet-panel__status-row'>
              <div className='search-facet-panel__status-title'>
                {chosenTags.split(',').join(', ')}
              </div>
            </div>
          </div>
        )
      }
    }

    const panelHeaderClassNames = classNames({
      'search-facet-panel__header--start': isAtTop,
      'search-facet-panel__header': !isAtTop,
      'is-active': showPanel
    })

    return (
      <div className='search-facet--no-margin' id='tags-filter'>
        <div className={panelHeaderClassNames} onClick={this.togglePanel}>
          <h2>
            <i className='e-icon -icon-tag -margin-right' />
            Tags
          </h2>
          {renderChosenTags()}
        </div>

        {showPanel &&
          <OnKeyDown onKeyDown={this.onKeyDownHandler}>
            <ClickOutside onClickOutside={this.togglePanel}>
              <FiltersMultiSelectPanel
                type='tags'
                showPanel={showPanel}
                items={items}
                parsedLocation={parsedLocation}
                togglePanel={this.togglePanel}
              />
            </ClickOutside>
          </OnKeyDown>
        }
      </div>
    )
  }
}

FiltersTags.propTypes = {
  location: PropTypes.object.isRequired,
  items: PropTypes.array
}

export const FiltersTagsComponent = FiltersTags
export default withRouter(FiltersTags)



// WEBPACK FOOTER //
// ./client/components/filters/filtersTags.js